import React, { useContext } from 'react';
import {Routes, Route, Navigate, useLocation} from 'react-router-dom';
import { MyContext } from './context/my_context';
import {CaptureProvider, ModuloProvider, SellerProvider} from './context/seller_context';
import Header from './components/header';
import HeaderAux from './components/header_aux';
import Login from './components/login';
import QrReaderView from './components/qr_reader_view';
import HelpSupport from './components/help_support';
import SellerInfo from './components/seller_profile';
import UserProfile from './components/user_profile';
import SearchSellerByDocument from './components/search_seller_by_document';
import FaceRecognition from "./components/face_recognition";
import GenerateReport from "./components/generate_report";
import FingerprintScanner from "./components/bluetooth_component_final";
import Home from './components/home';
import './App.css';

function App() {
    const context = useContext(MyContext);
    const location = useLocation();

    if (context === undefined) {
        throw new Error('App must be used within a MyProvider');
    }

    const { isAuthenticated } = context;

    return (
        <div className="App">
            <header className="App-header">
                {isAuthenticated && (
                    // Display the header based on the location
                    location.pathname === '/home' ? <Header /> : <HeaderAux />
                )}
            </header>
            <main>
                {isAuthenticated ? (
                    <SellerProvider> {/* Wrap the content with VendorProvider */}
                        <ModuloProvider>
                            <CaptureProvider>
                                <Routes>
                                <Route path="/home" element={<Home />} />
                                <Route path="/user_profile" element={<UserProfile/>} />
                                <Route path="/qr_reader_view" element={<QrReaderView/>} />
                                <Route path="/help_support" element={<HelpSupport/>} />
                                <Route path="/seller_profile" element={<SellerInfo />} />
                                <Route path="/face_recognition" element={<FaceRecognition />} />
                                <Route path="/bluetooth_component_final" element={<FingerprintScanner />} />
                                <Route path="/generate_report" element={<GenerateReport />} />
                                <Route path="/search_seller_by_document" element={<SearchSellerByDocument />} />
                                <Route path="*" element={<Navigate to="/home" />} />
                                </Routes>
                            </CaptureProvider>
                        </ModuloProvider>
                    </SellerProvider>
                ) : (
                    <Routes>
                        <Route path="/" element={<Login />} />
                        <Route path="*" element={<Navigate to="/" />} />
                    </Routes>
                )}
            </main>
        </div>
    );
}

export default App;

